// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Wkdf","footer":"ModalInfo_footer__1Rzsu"};